<template>
  <b-form-group class="mb-0">
    <b-form-checkbox v-model="checked" switch class="danger" :disabled="isDev || busy || disabled" @input="onToggle">
      <span v-if="!busy">{{ trans('test_mode_' + (checked ? 'on' : 'off')) }}</span>
      <small v-if="!busy && !!title" class="text-muted" :title="title" v-b-tooltip.hover>
        <i class="fa fa-fw fa-info-circle"></i>
      </small>
      <span v-if="busy">
        <i class="fa fa-fw fa-circle-notch fa-spin"></i>
        {{ trans('please_wait') }}
      </span>
    </b-form-checkbox>
  </b-form-group>
</template>

<script>
  export default {
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      value: {
        type: Boolean,
        default: false,
      },
      title: String,
      url: String,
    },
    data() {
      return {
        trans: trans,
        isDev: _.isDev,
        busy: false,
        error: null,
        checked: this.value,
      }
    },
    methods: {
      onToggle() {
        this.busy = true
        this.error = null
        axios.post(this.url, {is_test_mode: this.checked})
        .then(response => {
          window.location.reload()
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.testModeComponent = this
    },
  }
</script>